import { render, staticRenderFns } from "./ChangeEmailView.vue?vue&type=template&id=b5bd7030&lang=pug"
import script from "./ChangeEmailView.vue?vue&type=script&lang=js"
export * from "./ChangeEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports